import React from 'react';
import CarauselComp from 'atoms/Carausel/Presentation/CarauselComp';
import ProductListingModalOptions from 'organisms/ProductListingModalOptions/Container/ProductListingModalOptionsComponent';
import { getAndCheck, UpsellCrossellClassName } from 'common/utilities/utils';

const UpsellCrossell = props => {
  const {
    cardRenderer,
    productList,
    carousal,
    header = '',
    subHeader = '',
    settings,
    maxLengthToScroll: CONTENT_DATA_MAX_LENGTH_TO_SCROLL,
    slidesToShow: SLIDES_TO_SHOW,
    rangeValue,
    onUpdateRange,
    showProductListingModal,
    isMobile,
    recommendedRule,
    flagUpsellCrossell,
    tenantData,
  } = props;
  const showCountBox = tenantData?.componentOptions?.web?.pdp?.shouldShowRecommendationCardCount;

  return (
    <>
      {Boolean(productList?.length) && (
        <div className={UpsellCrossellClassName()} data-testid='recommendedCard-container-test'>
          <div className='recommendedContainerHeader-items'>
            <div className={subHeader ? 'pdp-carousal-header' : 'recommendedContainer-header'}>
              <span className='main-header'>{header}</span>
              {subHeader && <span className='sub-header'>{subHeader}</span>}
            </div>
            {showCountBox && (
              <span className='count_box'>
                {Math.round(rangeValue + 1)}/{productList.length}
              </span>
            )}
          </div>
          <div className='recommendedCard-list'>
            <div className='recommendedCarousal-list'>
              <CarauselComp settings={settings} carousalRef={carousal}>
                {cardRenderer()}
              </CarauselComp>
            </div>
            {productList.length > CONTENT_DATA_MAX_LENGTH_TO_SCROLL && (
              <div className='recommended-slideContainer'>
                <input
                  className='recommended-slider'
                  type='range'
                  min='0'
                  max={productList.length - SLIDES_TO_SHOW}
                  value={rangeValue}
                  id='myRange'
                  data-testid='myRange'
                  onChange={onUpdateRange}
                />
              </div>
            )}
          </div>
        </div>
      )}
      {getAndCheck(showProductListingModal, recommendedRule === flagUpsellCrossell) && (
        <div className={`pdp-custm-container ${isMobile ? 'mobile' : ''}`}>
          <div className='d-flex'>
            <ProductListingModalOptions />
          </div>
        </div>
      )}
    </>
  );
};

export default UpsellCrossell;
